import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import { Close, Home } from '@material-ui/icons';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { wsRemove, wsUpdate } from 'services/WService.js';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import StockData from './Stocks/StockData';

export default function ValueSellGroup(props) {
  const statePromo = props.promo.state == 'N' || props.promo.state == 'G' ? false : true;
  const [discount, setDiscount] = useState(props.sellGroup?.discount);

  const [dataSellGroup, setDataSellGroup] = useState(props.sellGroup);
  const [open, setOpen] = useState(false);

  async function deleteSellGroup() {
    let response = await wsRemove('prom/product-group', props.sellGroup.id);
    if (response.success) {
      props.showNotify(response.message);
      props.reload();
    }
  }

  async function updateSellGroup(data) {
    let response = await wsUpdate('prom/product-group', props.sellGroup.id, data);
    if (response.success) {
      props.showNotify(response.message);
    } else {
      props.showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    setDataSellGroup(props.sellGroup);
    setDiscount(props.sellGroup.discount);
  }, [props.sellGroup, props.rule?.id]);

  return (
    <GridContainer>
      {open && props.sellGroup?.products?.length > 0 ? (
        <ModalFull
          title={'Stock por almacénes del grupo ' + props.grupo}
          open={open}
          setOpen={setOpen}
        >
          <StockData idGroup={props.sellGroup.id} entity="prom/product-group" tipo="S" />
        </ModalFull>
      ) : undefined}

      {props.promo.bonification_type === 'P' ? (
        <GridItem xs={4}>
          <TextField
            key={dataSellGroup.quantity_group}
            id="quantity_group"
            label="Cantidad grupo"
            type="number"
            name="quantity_group"
            defaultValue={dataSellGroup.quantity_group || ''}
            onChange={(e) => updateSellGroup({ quantity_group: e.target.value })}
            inputProps={{ min: 0 }}
            disabled={statePromo}
          />
        </GridItem>
      ) : (
        <GridItem xs={4}>
          <TextField
            label="Descuento"
            type="number"
            name="discount"
            fullWidth
            value={discount || ''}
            onChange={(e) => {
              setDiscount(e.target.value);
              if (props.promo.bonification_type === 'D' && e.target.value > 70) {
                props.showNotify('El máximo aceptado es 70', 'info');
                setDiscount(70);
                updateSellGroup({ discount: 70 });
              } else {
                if (e.target.value < 1 || e.target.value === '') {
                  setDiscount(1);
                  updateSellGroup({ discount: 1 });
                  props.showNotify('El mínimo aceptado es 1', 'info');
                  return false;
                } else {
                  updateSellGroup({ discount: e.target.value });
                }
              }
            }}
            inputProps={{ min: 1, max: props.promo.bonification_type === 'D' ? 60 : null }}
            disabled={statePromo}
          />
        </GridItem>
      )}
      <GridItem xs={4}>
        <FormControlLabel
          label="Usar comparador 'O'"
          control={
            <Checkbox
              margin="normal"
              checked={dataSellGroup.or_comparation || false}
              onChange={(e) => {
                setDataSellGroup({ ...dataSellGroup, or_comparation: e.target.checked });
                updateSellGroup({ or_comparation: e.target.checked })}
              }
            />
          }
        />
      </GridItem>

      <GridItem xs={4}>
        <Button
          justIcon
          color="danger"
          disabled={statePromo}
          onClick={() => props.confirmDeleteGroup(deleteSellGroup)}
        >
          <Close />
        </Button>
        {props.sellGroup?.products.length > 0 ? (
          <Button
            justIcon
            color="primary"
            style={{ marginLeft: '15px' }}
            onClick={() => setOpen(true)}
          >
            <Home />
          </Button>
        ) : undefined}
      </GridItem>
    </GridContainer>
  );
}
